// extracted by mini-css-extract-plugin
module.exports = {"Container":"ListError_Container__BWAPQ","Header":"ListError_Header__VpgPZ","Description":"ListError_Description__yb86p","List":"ListError_List__YOStF"};